import { IAgent } from "./../../../store/modules/agent/agent.models";

import { Component, Prop, Watch } from "vue-property-decorator";
import { VueWizard } from "@/vue-wizard";
import { store, storeTypes } from "@/app/store";
import {
  BusinessStatus,
  Conversation,
} from "@/app/store/modules/conversation/conversation.models";
import { Subscription, fromEvent } from "rxjs";
import * as moment from "moment";
import $ from "jquery";
import { PerfectScrollbar } from "vue2-perfect-scrollbar";

import { IUser } from "@/app/store/modules/user/user.models";
import eventBus from "@/main";

@Component({
  name: "conversations-category-list",
  components: {
    PerfectScrollbar,
  },
})
export default class ConversationsCategoryList extends VueWizard {
  @Prop() public readonly conversations!: Conversation[];
  @Prop() public readonly categoryIdentification!: string;
  @Prop() public readonly parentAccordion!: string;
  @Prop() public readonly categoryTitle!: string;

  @Prop() public readonly businessStatuses!: BusinessStatus[];
  @Prop() public readonly showCollapse!: boolean;
  @Prop() public readonly currentList!: number;
  @Prop() public readonly listNumber!: number;
  @Prop() public readonly noFilteredConversations!: Conversation[];
  @Prop() public readonly activeFilters!: string[];
  public userLoged: IUser | null = store.state.user!.user;
  public agentLogued: IAgent | null = store.state.agent!.agent;
  public collapseElement: JQuery<Element> | null = null;
  public collapseShowSubscription: Subscription | null = null;
  public currentPage = 1; // lo inicializo enb uno porque por defecto en el login carga la pagina cero

  get loading(): any {
    return store.state.user!.loading;
  }

  mounted(): void {
    this.collapseElement = $(
      `#${this.categoryIdentification}-conversations-collapse`
    );
    this.collapseShowSubscription = fromEvent(
      this.collapseElement,
      "show.bs.collapse"
    ).subscribe(() => this.$emit("openCollapse", this.listNumber));
    this.onCurrentListChange();
  }

  beforeDestroy(): void {
    if (this.collapseShowSubscription) {
      this.collapseShowSubscription.unsubscribe();
    }
  }

  @Watch("currentList")
  onCurrentListChange(): void {
    if (this.collapseElement) {
      if (this.currentList === this.listNumber) {
        this.collapseElement.collapse("show");
      }
    }
  }

  onSelect(conversation: Conversation): void {
    this.$emit("selectConversation", conversation);
  }

  geInitials(conversation: Conversation): string {
    let userName = "C";
    if (
      conversation != undefined &&
      conversation.variables != undefined &&
      conversation.variables.CONSUMER_NAME &&
      conversation.variables.CONSUMER_NAME.value != undefined &&
      isNaN(conversation.variables.CONSUMER_NAME.value)
    ) {
      userName = conversation.variables.CONSUMER_NAME.value;
      if (userName != undefined && userName != "" && userName != null) {
        userName = userName.charAt(0);
      }
    }
    return userName;
  }

  getUserPicture(conversation: Conversation): string {
    let profileUrl = "";

    if (
      conversation != undefined &&
      conversation.variables != undefined &&
      conversation.variables.CONSUMER_PROFILE_PICTURE != undefined &&
      conversation.variables.CONSUMER_PROFILE_PICTURE.value != undefined
    ) {
      profileUrl = conversation.variables.CONSUMER_PROFILE_PICTURE.value;
    }
    return profileUrl;
  }

  getConsumer(conversation: Conversation): string {
    let consumer = conversation.currentConsumer;
    if (consumer.includes("@")) consumer = consumer.split("@")[0];
    return consumer;
  }

  getUserName(conversation: Conversation): string {
    let userName = "";
    if (
      conversation != undefined &&
      conversation.variables != undefined &&
      conversation.variables.CONSUMER_NAME
    ) {
      userName = conversation.variables.CONSUMER_NAME.value;
    }
    return userName;
  }

  cleanTopic(topic: string): string {
    let topicElements: any[] = [];
    if (topic.includes("_")) {
      topicElements = topic.split("_");
      topic = "";
      for (let i = 2; i < topicElements.length; i++) {
        topic = topic + topicElements[i] + " ";
      }
      topic.trim();
    }
    return topic;
  }

  getTopic(conversation: Conversation): string {
    return this.cleanTopic(conversation.currentTopic);
  }

  formatUpdatedDate(date: Date | string): string {
    moment.locale("es");
    const today = new Date();
    const toFormatDate = new Date(date.toString());
    if (today.getFullYear() === toFormatDate.getFullYear()) {
      if (
        today.getDay() === toFormatDate.getDay() &&
        toFormatDate.getMonth() === today.getMonth()
      ) {
        return moment.default(date).format("hh:mm a");
      } else {
        return moment.default(date).format("DD MMM");
      }
    } else {
      return moment.default(date).format("DD/MM/YYYY");
    }
  }

  statusColorStyle(status: BusinessStatus): any {
    if (status) {
      return {
        "--label-bg-color-r": this.hexToRgb(status.color)
          ? (this.hexToRgb(status.color) as any).r
          : 0,
        "--label-bg-color-g": this.hexToRgb(status.color)
          ? (this.hexToRgb(status.color) as any).g
          : 0,
        "--label-bg-color-b": this.hexToRgb(status.color)
          ? (this.hexToRgb(status.color) as any).b
          : 0,
      };
    } else {
      return {};
    }
  }

  hexToRgb(hex: string): any {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : null;
  }

  getBusinessStatus(status: string): BusinessStatus | undefined {
    return this.businessStatuses.find(
      (businessStatus: BusinessStatus) => businessStatus.name === status
    );
  }

  get currentConversation(): any {
    return store.state.conversation!.currentConversation;
  }

  get alertNewInteractions(): boolean {
    let newInteractions = 0;
    this.noFilteredConversations.forEach((conversation: Conversation) => {
      if (conversation.newinteractions) {
        newInteractions += conversation.newinteractions;
      }
    });
    return newInteractions > 0;
  }

  /***
   * paginacion
   */
  async loadMore(): Promise<void> {
    if (this.categoryIdentification == "queue") {
      await store.dispatch(
        storeTypes.agent.actions.loadAgentQueues({
          subscriptions: store.state.agent!.agent!.subscriptions,
          page: this.currentPage,
        })
      );
      this.currentPage = this.currentPage + 1;
    }

    if (this.categoryIdentification == "active") {
      await store.dispatch(
        storeTypes.agent.actions.loadAgentOpenConversations({
          agent_id: store.state.agent!.agent!._id,
          page: this.currentPage,
          limit: 50,
        })
      );
      this.currentPage = this.currentPage + 1;
    }
    if (this.categoryIdentification == "resolved") {
      await store.dispatch(
        storeTypes.agent.actions.loadAgentCloseConversations({
          agent_id: store.state.agent!.agent!._id,
          page: this.currentPage,
        })
      );
      this.currentPage = this.currentPage + 1;
    }
  }

  created(): void {
    eventBus.$on("changepage", () => {
      this.currentPage = 1;
    });
  }
}
